module.exports = __webpack_public_path__ + "static/media/honeymoonline-logo.d2b62b9b.jpg";